import { render } from "./BookingCard.vue?vue&type=template&id=50254ccd&scoped=true"
import script from "./BookingCard.vue?vue&type=script&lang=js"
export * from "./BookingCard.vue?vue&type=script&lang=js"

import "./BookingCard.vue?vue&type=style&index=0&id=50254ccd&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50254ccd"]])

export default __exports__